{
  "meta-title": "Edit Client Notes",
  "heading": "Notes",
  "notes-text-area-placeholder": "Add notes."
}
